export const MIRA_LEARN_MORE_URL =
  "https://learn.miracare.com/hubfs/Customized%20patient%20handouts/My%20Fertility%20Labs.pdf";

export const MIRA_SHOP_URL = "https://mira-fertility.pxf.io/3JO3rk";
